<template lang="pug">
v-layout(column)
  .pa-4(v-if='initialized')
    template(v-if='isNew')
      h2(v-if='isBusinessLease') Nieuwe Financial Lease aanvraag
      h2(v-else) Nieuwe Krediet aanvraag
    template(v-else)
      h2(v-if='isBusinessLease') Financial Lease aanvraag {{ payload.number }}
      h2(v-else) Krediet aanvraag {{ payload.number }}
    small(v-if='payload.createdAt') Aanvraag ingediend op: {{ payload.createdAt | moment('DD-MM-YYYY HH:mm') }}

    v-alert.mb-4(type='warning', :value='payload.testLease') Dit is een test aanvraag. Exports zijn niet uitgevoerd.

    v-tabs.mt-4(v-model='activeTab', v-if='isBusinessLease')
      v-tab(key='lease') Lease
      v-tab(key='product') Productgegevens
      v-tab(key='company') Bedrijfsgegevens
      v-tab(key='info') Info

      v-tab-item(key='lease')
        v-card.pa-4.ma-1.mt-4
          DomainSelector(
            :readonly='!isNew',
            v-model='payload.domain',
            :isBusinessLease='isBusinessLease'
            )

        v-card.pa-4.ma-1.mt-4(:class='{ "disabled-overlay": !payload.domain }', v-if='!isNew && (payload.productImage || payload.originUrl)')
          ProductInfo

        v-card.pa-4.ma-1.mt-4(:class='{ "disabled-overlay": !payload.domain }', v-if='!isNew || Object.keys(domainInfo).length > 0')
          FieldsLeaseDetails(
            v-model='payload.leaseModel',
            @setValid='setValid',
            :isBusinessLease='isBusinessLease',
            :pvInputAllowed='true',
            @setCalculated='setCalculated',
            :calculateFunction='calculateFunction',
            ref='leaseModelFields',
            :productType='payload.productType',
            @setProductType='(v) => payload.productType = v'
            )

      v-tab-item(key='product')
        v-card.px-4.pt-4.ma-1.mt-4
          FieldsProductDetails.pa-1(
            v-model='payload.productProperties',
            :productType='payload.productType'
            )

      v-tab-item(key='company')
        v-card.px-4.pt-4.ma-1.mt-4
          FieldsCompanyDetails.pa-1(
            v-model='payload.companyModel',
            @setValid='setValid',
            :showCompanyFields='true'
            )

      v-tab-item(key='info')
        v-card.px-4.ma-1.mt-4.pt-4.pb-4
          FieldsLeaseOptionsDetails(
            v-if='payload.leaseOptionsModel',
            v-model='payload.leaseOptionsModel'
            )

          FieldsBusinessInfoDetails.pa-1(
            v-model='payload.infoModel',
            @setValid='setValid',
            :isPortal='true',
            :isNew='isNew',
            :leaseOptions='payload.leaseOptions'
            )

    v-tabs.mt-4(v-model='activeTab', v-else)
      v-tab(key='lease') Lease
      v-tab(key='product') Productgegevens
      v-tab(key='personal') Persoonsgegevens
      v-tab(key='work') Werksituatie
      v-tab(key='financial') Financiële gegevens
      v-tab(key='loan') Leningen
      v-tab(key='info') Info

      v-tab-item(key='lease')
        v-card.pa-4.ma-1.mt-4
          DomainSelector(
            :readonly='!isNew',
            v-model='payload.domain',
            :isBusinessLease='isBusinessLease'
            )

        v-card.pa-4.ma-1.mt-4(:class='{ "disabled-overlay": !payload.domain }', v-if='!isNew && (payload.productImage || payload.originUrl)')
          ProductInfo

        v-card.pa-4.ma-1.mt-4(:class='{ "disabled-overlay": !payload.domain }', v-if='Object.keys(domainInfo).length > 0')
          FieldsLeaseDetails(
            v-model='payload.leaseModel',
            @setValid='setValid',
            :isBusinessLease='isBusinessLease',
            :pvInputAllowed='true',
            @setCalculated='setCalculated',
            :calculateFunction='calculateFunction',
            ref='leaseModelFields',
            :productType='payload.productType',
            @setProductType='(v) => payload.productType = v'
            )

      v-tab-item(key='product')
        v-card.px-4.pt-4.ma-1.mt-4
          FieldsProductDetails.pa-1(
            v-model='payload.productProperties',
            @setValid='setValid',
            :productType='payload.productType'
            )

      v-tab-item(key='personal')
        v-card.px-4.ma-1.mt-4
          FieldsPersonalDetails.pa-1(
            v-model='payload.personalFieldsData',
            @setValid='setValid'
            )

      v-tab-item(key='work')
        v-card.px-4.ma-1.mt-4.pt-4
          FieldsWorkDetails.pa-1(
            v-model='payload.workModel',
            @setValid='setValid'
            )

      v-tab-item(key='financial')
        v-card.px-4.ma-1.mt-4.pt-4
          FieldsFinancialDetails.pa-1(
            v-model='payload.financialModel',
            @setValid='setValid',
            :showAlimonyFields='payload.personalFieldsData.personalModel.alimony'
            )

      v-tab-item(key='loan')
        v-card.px-4.ma-1.mt-4.pt-4
          FieldsLoanDetails.pa-1(
            v-model='payload.loanModel',
            @setValid='setValid'
            )

      v-tab-item(key='info')
        v-card.px-4.ma-1.mt-4.pt-4.pb-4
          FieldsLeaseOptionsDetails(
            v-if='payload.leaseOptionsModel',
            v-model='payload.leaseOptionsModel'
            )

          FieldsPrivateInfoDetails.pa-1(
            v-model='payload.infoModel',
            @setValid='setValid',
            :isPortal='true',
            :isNew='isNew',
            :leaseOptions='payload.leaseOptions'
            )

    v-layout.mt-2
      v-btn(@click='activeTab--', v-if='activeTab !== 0 && isNew') Vorige
      v-spacer
        //- v-btn(@click='save', color='primary', v-if='activeTab === lastTabNumber || !isNew', :loading='loading', :disabled='$v.$invalid || !calculated')
          v-icon.mr-2 fa fa-check
          | Opslaan
      v-btn(@click='activeTab++', color='primary', v-if='activeTab !== lastTabNumber', :disabled='!isNew && $v.$invalid') Volgende

</template>

<script>
import axios from 'axios'

export default {
  name: 'LeaseDetails',

  components: {
    DomainSelector: require('./DomainSelector').default,
    ProductInfo: require('./ProductInfo').default,
    FieldsCompanyDetails: require('dealerfinanceservices-shared/src/FieldsCompanyDetails').default,
    FieldsLeaseDetails: require('dealerfinanceservices-shared/src/FieldsLeaseDetails').default,
    FieldsPersonalDetails: require('dealerfinanceservices-shared/src/FieldsPersonalDetails').default,
    FieldsWorkDetails: require('dealerfinanceservices-shared/src/FieldsWorkDetails').default,
    FieldsFinancialDetails: require('dealerfinanceservices-shared/src/FieldsFinancialDetails').default,
    FieldsLoanDetails: require('dealerfinanceservices-shared/src/FieldsLoanDetails').default,
    FieldsPrivateInfoDetails: require('dealerfinanceservices-shared/src/FieldsPrivateInfoDetails').default,
    FieldsProductDetails: require('dealerfinanceservices-shared/src/FieldsProductDetails').default,
    FieldsBusinessInfoDetails: require('dealerfinanceservices-shared/src/FieldsBusinessInfoDetails').default,
    FieldsLeaseOptionsDetails: require('dealerfinanceservices-shared/src/FieldsLeaseOptionsDetails').default
  },

  data () {
    return {
      activeTab: 0,
      loading: false,
      calculated: false,
      initialized: false,

      payload: {
        leaseModel: {},
        infoModel: {},
        companyModel: {},
        productProperties: {},
        personalFieldsData: {
          personalModel: {},
          partnerModel: {}
        },
        workModel: {},
        financialModel: {},
        loanModel: {},
        leaseOptionsModel: []
      },

      leaseModelValid: false,
      companyModelValid: false,
      personalModelValid: false,
      workModelValid: false,
      financialModelValid: false,
      loanModelValid: false,
      infoModelValid: false,

      domainInfo: {}
    }
  },

  computed: {
    lastTabNumber () {
      return this.isBusinessLease ? 3 : 6
    },

    isNew () {
      return this.$route.params.leaseId.includes('nieuwe-')
    },

    isBusinessLease () {
      return this.payload.__typename === 'BusinessLease' || this.$route.params.leaseId.includes('-financiallease-')
    },

    currentExportMethods () {
      return this.$store.state.organization.current.exportMethods
    },

    leaseId () {
      return this.$route.params.leaseId
    }
  },

  methods: {
    async calculateFunction (params) {
      if (!this.payload.domain) return false

      params.domain = this.payload.domain

      const { data } = await axios({
        method: 'POST',
        url: `/calc/${this.isBusinessLease ? 'business' : 'private'}/lease`,
        params
      })

      return data
    },

    setValid ({ modelName, valid }) {
      this[modelName + 'Valid'] = valid
    },

    setCalculated (v) {
      this.calculated = v
    },

    async save () {
      let rerunCustomerMail = false
      if (!this.isNew) {
        const rerunCustomerMailMsg = `Wil je deze lease opnieuw naar de klant mailen?

De klant zal een nieuwe e-mail ontvangen met de lease PDF en eventuele documenten als bijlage.`

        rerunCustomerMail = await this.$root.$choice('Opnieuw klant mailen', rerunCustomerMailMsg, {
          color: 'primary',
          confirmLabel: 'E-mail versturen'
        })
      }

      this.loading = true

      let mutationName
      let variables = {}

      // Shared
      if (!this.isNew) variables.id = this.leaseId
      variables.domain = this.payload.domain
      variables.infoModel = this.payload.infoModel
      variables.leaseOptionsModel = this.payload.leaseOptionsModel
      variables.leaseModel = this.payload.leaseModel
      variables.productProperties = this.payload.productProperties

      // Specific
      if (this.isBusinessLease) {
        mutationName = 'updateBusinessLease'

        variables.companyModel = this.payload.companyModel
      } else {
        mutationName = 'updatePrivateLease'

        variables.personalModel = this.payload.personalFieldsData.personalModel
        variables.partnerModel = this.payload.personalFieldsData.partnerModel
        variables.workModel = this.payload.workModel
        variables.financialModel = this.payload.financialModel
        variables.loanModel = this.payload.loanModel
      }

      // Delete values that server calculates and that we aren't allowed to set
      delete variables.leaseModel.pmt
      delete variables.leaseModel.rate
      delete variables.leaseModel.totalLoanAmount
      delete variables.infoModel.uniqueNumber
      delete variables.infoModel.dateCreated

      if (variables.partnerModel && Object.keys(variables.partnerModel).length === 0) delete variables.partnerModel // Server wants an actual filled partnerModel or nothing at all

      try {
        const deleteCacheQueries = ['getAllLeases', 'getAllBusinessLeases', 'getAllPrivateLeases'] // Could optimise: only need to to remove the lease type that was added.

        if (this.isNew) {
          await axios.post('/form/submit/lease', variables)

          for (const q of deleteCacheQueries) {
            await this.$store.dispatch('deleteStoreQuery', q)
          }

          this.$root.$snackbar.show('Nieuwe lease aanvraag is ingediend')
        } else {
          await this.$store.dispatch('graphqlMutation', {
            name: mutationName,
            variables,
            deleteCacheQueries
          })

          await this.$store.dispatch('graphqlMutation', {
            name: 'rerunLeaseExports',
            variables: {
              id: this.leaseId
            },
            deleteCacheQueries
          })

          if (rerunCustomerMail) {
            await this.$store.dispatch('graphqlMutation', {
              name: 'rerunCustomerMail',
              variables: {
                id: this.leaseId
              }
            })
          }

          let msg = 'Lease aanvraag aangepast'

          if (rerunCustomerMail) msg += ', exports opnieuw uitgevoerd & klant gemaild'
          else msg += ' & exports opnieuw uitgevoerd'

          this.$root.$snackbar.show(msg)
        }

        this.$router.push({
          name: 'all leases'
        })
      } catch (error) {
        console.error(error)

        this.$root.$snackbar.show('Er is iets fout gegaan. Probeer het nog een keer.')
      }

      this.loading = false
    }
  },

  async created () {
    if (!this.isNew) {
      try {
        this.payload = await this.$store.dispatch('graphqlQuery', {
          name: 'getLease',
          variables: {
            id: this.$route.params.leaseId
          },
          ignoreCache: true
        })
      } catch (error) {
        if (error.message.includes('lease not found')) {
          this.$root.$snackbar.show('Deze lease bestaat niet')

          this.$router.go(-1)
          return
        } else {
          throw error
        }
      }

      this.payload.personalFieldsData = {
        personalModel: this.payload.personalModel,
        partnerModel: this.payload.partnerModel || {}
      }
    } else {
      // New lease, add some defaults

      if (this.isBusinessLease) {
        this.payload.companyModel.country = 'NL'
      } else {
        this.payload.personalFieldsData.personalModel.nationality = 'NL'
        this.payload.loanModel.otherLoans = false
        this.payload.financialModel.otherIncome = false
      }

      if (this.$route.query.leasebedrag) this.$set(this.payload.leaseModel, 'pv', parseInt(this.$route.query.leasebedrag)) // Only query is in dutch
      if (this.$route.query.slottermijn) this.$set(this.payload.leaseModel, 'fv', parseInt(this.$route.query.slottermijn))
      if (this.$route.query.looptijd) this.$set(this.payload.leaseModel, 'nper', parseInt(this.$route.query.looptijd))
      if (this.$route.query.aanbetaling) this.$set(this.payload.leaseModel, 'deposit', parseInt(this.$route.query.aanbetaling))
    }

    this.$watch('payload', (v) => {
      if (this.isNew) {
        if (this.isBusinessLease ? v.infoModel.confirmTos : v.infoModel.confirmCheckAndProcessing) this.$root.$save.show(this.save, null, 'Wil je deze lease aanvraag opslaan?')
      } else {
        this.$root.$save.show(this.save, null)
      }

      this.$root.$save.setValid(!this.$v.$invalid)
    }, { deep: true })
    this.$watch('$v.$invalid', (v) => this.$root.$save.setValid(!v), { deep: true }) // Must be last

    this.initialized = true
  },

  validations: {
    leaseModelValid: {
      truthy: (v, vm) => !!v
    },

    infoModelValid: {
      truthy: (v, vm) => !!v
    },

    companyModelValid: {
      truthy: (v, vm) => !vm.isBusinessLease || !!v
    },

    personalModelValid: {
      truthy: (v, vm) => vm.isBusinessLease || !!v
    },

    workModelValid: {
      truthy: (v, vm) => vm.isBusinessLease || !!v
    },

    financialModelValid: {
      truthy: (v, vm) => vm.isBusinessLease || !!v
    },

    loanModelValid: {
      truthy: (v, vm) => vm.isBusinessLease || !!v
    },

    calculated: {
      truthy: (v) => v
    }
  },

  watch: {
    'payload.domain': {
      handler: async function (domain) {
        if (this.isNew) {
          const { data } = await axios({
            url: '/form/domain-info',
            method: 'POST',
            params: {
              domain
            }
          })

          this.domainInfo = data

          this.$set(this.payload, 'productType', data.productType)

          if (this.isBusinessLease) {
            if (!this.$route.query.slottermijn) this.$set(this.payload.leaseModel, 'fv', data.businessFormDefaultFv) // Querystring is used when coming from the calculator
            if (!this.$route.query.looptijd) this.$set(this.payload.leaseModel, 'nper', data.businessFormDefaultNper)
          } else {
            if (!this.$route.query.slottermijn) this.$set(this.payload.leaseModel, 'fv', data.privateFormDefaultFv)
            if (!this.$route.query.looptijd) this.$set(this.payload.leaseModel, 'nper', data.privateFormDefaultNper)
          }

          this.payload.leaseModel.deposit = 0

          this.payload.leaseOptionsModel = data.leaseOptions
        }

        if (this.$refs.leaseModelFields) {
          this.$refs.leaseModelFields.triggerRecalculate()
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.v-card.disabled-overlay {
  position: relative;
  pointer-events: none;

  &:after {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    content: "";
    background: rgba(150, 150, 150, 0.2);
  }
}
</style>
